import * as React from "react";
import YoutTubeComp from "../../util/YouTubeComp";
import MenuComp from "../../util/MenuComp";


function MontaComponente(props){
    const {cmp, edit} = props

    const doc = new DOMParser().parseFromString(cmp, "text/xml");
    const el = doc.firstChild;
    const nome = el.getAttribute("nome")
    // console.log(el.tagName); 
    // console.log( nome ); 
    // console.log(el.getAttributeNames() );
    if( nome === "YouTubeComp"){
        return (
            <YoutTubeComp tipo={el.getAttribute("tipo")} edit={edit}/>
        )
    }
    if( nome === "Menu"){
        return (
            // <YoutTubeComp tipo={el.getAttribute("tipo")} edit={edit}/>
            <MenuComp tipo={el.getAttribute("tipo")} nomePagina={el.getAttribute("pagina")} edit={edit} />
        );
    }
    return (
        <div>{cmp}</div>
    )
}

const HtmlContentPage = ({ htmlString, edit }) => {
    let arr = [];
    let index =0;
    let tmp = String(htmlString);
    
    while( tmp.indexOf("<componente") >= 0){     
        let pos = tmp.indexOf("<componente");
        let pos2 = tmp.indexOf("</componente>");
        let comp = tmp.substring(pos, pos2+"</componente>".length)

        arr.push(htmlString.substring(0, pos));
        arr.push( comp );
        
        tmp = tmp.substring(pos2+"</componente>".length, htmlString.length);
        if( index++ > 10) break;

    }
    arr.push( tmp );    
    if( arr.length > 0 ){        
        return (
            <React.Fragment>
                {arr.map((c, index)=>{        
                    if(c.includes("<componente")){
                        return(
                            <MontaComponente cmp={c} edit={edit} key={index} />
                        )
                    }
                    return (
                        <div key={index}
                            dangerouslySetInnerHTML={{ __html: c }}
                        />
                    )
                })}
            </React.Fragment>
        )
    }else{
        console.log(3)
        return (
        <div
            dangerouslySetInnerHTML={{ __html: htmlString }}
        />
        );
    }
  };

  export default HtmlContentPage;